/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {BROWSER_ANIMATIONS_PROVIDERS, BROWSER_NOOP_ANIMATIONS_PROVIDERS} from './providers';
/**
 * \@experimental Animation support is experimental.
 */
export class BrowserAnimationsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [BrowserModule],
  providers: BROWSER_ANIMATIONS_PROVIDERS,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BrowserAnimationsModule_tsickle_Closure_declarations() {
/** @type {?} */
BrowserAnimationsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BrowserAnimationsModule.ctorParameters;
}

/**
 * \@experimental Animation support is experimental.
 */
export class NoopAnimationsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [BrowserModule],
  providers: BROWSER_NOOP_ANIMATIONS_PROVIDERS,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NoopAnimationsModule_tsickle_Closure_declarations() {
/** @type {?} */
NoopAnimationsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NoopAnimationsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
